import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { CompaniesSelectionComponent } from './companies-selection/companies-selection.component';
import { WorkPackagesSelectionComponent } from './work-packages-selection/work-packages-selection.component';
import { SubmissionGuidlinesComponent } from './submission-guidlines/submission-guidlines.component';
import { CommonModule } from '@angular/common';
import { BriefSectionComponent } from '../brief-section/brief-section.component';
import { TenderingService } from '@/app/services/tendering-services/tendering.service';
@Component({
  selector: 'app-eoi-sections',
  standalone: true,
  imports: [
    CompaniesSelectionComponent,
    WorkPackagesSelectionComponent,
    SubmissionGuidlinesComponent,
    CommonModule,
    BriefSectionComponent,
  ],
  templateUrl: './eoi-sections.component.html',
  styleUrl: './eoi-sections.component.css',
})
export class EoiSectionsComponent implements OnInit, OnChanges {
  @Output() closeModalEvent = new EventEmitter<boolean>(); // EventEmitter to notify parent
  @Input() currentEOISavedData: any = [];

  project_name: string;
  currentStep = 1;
  eoiId!: number;
  projectId!: number;

  constructor(private tenderingService: TenderingService) {}
  ngOnInit(): void {
    this.project_name = localStorage.getItem('project-name');

    if (
      this.currentEOISavedData?.eoiStep &&
      this.currentEOISavedData?.eoiData?.id &&
      this.currentEOISavedData?.eoiData?.project_id
      // TODO: DOING CREATE NEW EOI
      // && !this.isNewEOI
    ) {
      this.currentStep = this.currentEOISavedData.eoiStep;
      this.eoiId = this.currentEOISavedData?.eoiData?.id;
      this.projectId = this.currentEOISavedData?.eoiData?.project_id;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['currentEOISavedData']) {
      if (
        this.currentEOISavedData?.eoiStep &&
        this.currentEOISavedData?.eoiData?.id &&
        this.currentEOISavedData?.eoiData?.project_id
        // TODO: DOING CREATE NEW EOI
        // && !this.isNewEOI
      ) {
        this.currentStep = this.currentEOISavedData.eoiStep;
        this.eoiId = this.currentEOISavedData?.eoiData?.id;
        this.projectId = this.currentEOISavedData?.eoiData?.project_id;
      }
    }
  }

  getEoiDetailsFromWPComponent(data: any) {
    this.eoiId = data.eoiId;
    this.projectId = data.projectId;
    this.currentEOISavedData.eoiData = {
      ...this.currentEOISavedData.eoiData,
      id: this.eoiId,
    };

    if (data?.updateWorkPackages) {
      this.currentEOISavedData = {
        ...this.currentEOISavedData,
        eoiData: {
          ...this.currentEOISavedData.eoiData,
          name: data?.updateWorkPackages?.eoi?.name,
          work_packages_details:
            data?.updateWorkPackages?.eoi?.work_packages_details,
          selected_work_packages: data?.updateWorkPackages.workPackages,
        },
      };
    } else if (data?.updatedOrganization) {
      this.currentEOISavedData = {
        ...this.currentEOISavedData,
        eoiData: {
          ...this.currentEOISavedData.eoiData,
          selected_organizations: data?.updatedOrganization,
        },
      };
    } else if (data?.updatedSubmissionGuidelines) {
      this.currentEOISavedData = {
        ...this.currentEOISavedData,
        eoiData: {
          ...this.currentEOISavedData.eoiData,
          eligibility_criteria:
            data?.updatedSubmissionGuidelines?.eligibility_criteria,
          issue_date: data?.updatedSubmissionGuidelines?.issue_date,
          epc_date: data?.updatedSubmissionGuidelines?.epc_date,
          inquiry_deadline: data?.updatedSubmissionGuidelines?.inquiry_deadline,
          submission_date: data?.updatedSubmissionGuidelines?.submission_date,
        },
      };
    }
  }

  nextStep() {
    if (this.currentStep < 4) {
      this.currentStep++;
    }
  }
  previousStep() {
    if (this.currentStep > 1) {
      this.currentStep--;
    }
  }

  handleCloseModal(closeModalValue: boolean) {
    if (closeModalValue) {
      this.closeModalEvent.emit(closeModalValue); // Emit closeModal value to the parent
    }
  }
  // ngDoCheck() {
  //   console.log('ngDoCheck', this.currentEOISavedData.eoiStep);
  // }
}
